module.exports = __webpack_public_path__ + "static/instagram-34dd378548064bc0254c5c8eb7de52fa.png";